import { API } from '../config/AppConfig';
import axios from 'axios';
import { AUDIT_RESULT, ATTACH_FILES_TO_CHART, MY_CHARTS } from '../constants/Endpoints';
import { whichTokenToUse } from '../utils/isManagerCreatedToken';

class MyChartRepository {
  async getCharts(query) {
    const response = await API.get(MY_CHARTS, {
      queryParams: query,
    });
    return response;
  }

  async getAuditResults(query) {
    const response = await API.get(AUDIT_RESULT, {
      queryParams: query,
    });
    return response;
  }

  async attachFiles(chartId, formData, onUploadProgress) {
    const token = localStorage.getItem(whichTokenToUse());
    const url = ATTACH_FILES_TO_CHART.replace(':chartId', chartId);
    const response = await axios.post(url, formData, {
      headers: {
        Authorization: token,
      },
      onUploadProgress,
    });
    return response;
  }
}

const myChartRepository = new MyChartRepository();
export default myChartRepository;
